import { InjectionToken, NgModule, APP_INITIALIZER } from '@angular/core';
import {
    MSAL_CONFIG,
    MSAL_CONFIG_ANGULAR,
    MsalAngularConfiguration
    , MsalService, MsalModule, MsalInterceptor
  } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Configuration } from 'msal';
import { ConfigLoaderService, appInitializerFactory } from './shared/config-loader.service';
import { GraphApiUrl, AzureManagementUrl } from './azuread/azuread-helper.service';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export function msalConfigFactory(config: ConfigLoaderService): Configuration {
    // https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options
    const msalConfig = {
        auth: {
          clientId: config.Configuration.msal.clientId,
          authority: config.Configuration.msal.authority,
          validateAuthority: true,
          redirectUri: config.Configuration.msal.redirectUri,
          postLogoutRedirectUri: config.Configuration.msal.postLogoutRedirectUri,
          navigateToLoginRequestUrl: true,
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: isIE, // set to true for IE 11
        },
        system: {
          // logger: new Logger(loggerCallback, {
          //   correlationId: 'msalRoot',
          //   level: LogLevel.Verbose,
          //   piiLoggingEnabled: true
          // })
        }
      };
    return (msalConfig as Configuration);
}

export function msalAngularConfigFactory(config: ConfigLoaderService): MsalAngularConfiguration {
    // https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options
    const auth = {
            popUp: isIE,
            consentScopes: [config.Configuration.msal.defaultScope] ,
            unprotectedResources: [],
            protectedResourceMap: [
              [GraphApiUrl, ['user.read']],
              [config.Configuration.azFunctions.baseUrl, [config.Configuration.azFunctions.defaultScope]], 
              [AzureManagementUrl, ["https://management.azure.com/user_impersonation"]]
            ],
            extraQueryParameters: {}
    };
    return (auth as MsalAngularConfiguration);
}

@NgModule({
    providers: [
    ],
    imports: [MsalModule]
})
export class MsalApplicationModule {

    static forRoot() {
        return {
            ngModule: MsalApplicationModule,
            providers: [
               {
                    provide: MSAL_CONFIG,
                    useFactory: msalConfigFactory,
                    deps: [ConfigLoaderService]
                },
                {
                    provide: MSAL_CONFIG_ANGULAR,
                    useFactory: msalAngularConfigFactory,
                    deps: [ConfigLoaderService]
                },
                MsalService,
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: MsalInterceptor,
                    multi: true
                }
            ]
        };
    }
}